import React from 'react';
import '../styles/SessionTimer.css';

const SessionTimer = () => {
  return (
    <div className="session-timer">
      🟢 Connecté en tant qu'administrateur
    </div>
  );
};

export default SessionTimer;